import React from 'react';
import PropTypes from 'prop-types';

import { VITALS_ACTIVITY_TYPE } from '../constants';

import BloodPressureChart from './BloodPressureChart';
import RespiratoryRateChart from './RespiratoryRateChart';
import BodySurfaceAreaChart from './BodySurfaceAreaChart';
import BodyTemperatureChart from './BodyTemperatureChart';

const {
  BLOOD_PRESSURE,
  RESPIRATORY_RATE,
  BODY_SURFACE_AREA,
  BODY_TEMPERATURE,
} = VITALS_ACTIVITY_TYPE;

const TimeScalableChart = ({ activeCardType, isTemperatureInCelsius }) => {
  switch (activeCardType) {
    case BLOOD_PRESSURE:
      return <BloodPressureChart />;
    case RESPIRATORY_RATE:
      return <RespiratoryRateChart />;
    case BODY_SURFACE_AREA:
      return <BodySurfaceAreaChart />;
    case BODY_TEMPERATURE:
      return (
        <BodyTemperatureChart isTemperatureInCelsius={isTemperatureInCelsius} />
      );
    default:
      return null;
  }
};

TimeScalableChart.propTypes = {
  activeCardType: PropTypes.string,
  isTemperatureInCelsius: PropTypes.bool,
};

export default TimeScalableChart;



// WEBPACK FOOTER //
// ./src/components/PatientHealthboard/TimeScalableChart/index.jsx